import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListPangkatGolongan } from "@/services/getData"

export default function MasterPangkatGolonganPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listPangkatGolongan"],
    queryFn: getListPangkatGolongan,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
